// extracted by mini-css-extract-plugin
module.exports = {"grid":"GovHomeHeader_grid__2Hhq7","load":"GovHomeHeader_load__1kZOv"};